<template>
  <div>
    <b-modal
      id="modal-role-edit"
      ref="my-modal"
      cancel-variant="outline-secondary"
      ok-title="Close"
      ok-only
      centered
      :title="$t('DEBTIA_LETTER_DETAILS')"
      size="lg"
    >
      <b-overlay
        :show="busy"
        no-wrap
      />
      <b-row>
        <b-col
          sm="6"
        >
          <b-form>
            <b-row>
              <b-col
                v-if="user_type === 'super-admin'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_COMPANY_NAME')"
                  label-for="title"
                  class="mb-2"
                >
                  <b-form-input
                    id="title "
                    v-model="companyname"
                    type="text"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_TITLE')"
                  label-for="title"
                  class="mb-2"
                >
                  <label>{{ name }}</label>
                </b-form-group>
              </b-col>
              <b-col
                v-if="document_name"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_DOCUMENT_NAME')"
                  label-for="document_name"
                  class="mb-2"
                >
                  <label>{{ document_name }}</label>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_DESCRIPTION')"
                  label-for="description"
                  class="mb-2"
                >
                  <label>{{ description }}</label>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_SAMPLE_REQUEST_BODY')"
                  label-for="variables"
                  class="mb-2"
                >
                  <div :class="user_type === 'super-admin' ? 'variables-admin':'variables'">
                    <pre>{{ apiBody }}</pre>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
        <b-col
          sm="6"
        >
          <iframe
            :src="pdfLink"
            width="100%"
            height="548px"
          />
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import axios from '@axios'
// import constants from '@/app-configs/constants'
import axiosletter from '../../libs/axiosletter'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    templateId: {
      type: Number,
      required: true,
    },
    templateBusy: {
      type: Boolean,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: '',
        subject: '',
        content: '',
        type: 'email',
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
        companyName: '',
      },
      id: 0,
      snowOption: {
        theme: 'snow',
      },
      required,
      details: {},
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      apiBody: '',
      pdfLink: '',
      name: '',
      document_name: '',
      description: '',
      companyname: '',
      busy: false,
      letter_client_id: '',
      letter_secret: '',
    }
  },
  watch: {
    templateId: {
      handler() {
        this.id = this.templateId
        this.busy = this.templateBusy
        this.getDetails(this.id)
      },
    },
  },
  created() {
    this.getLetterApiSettings()
    // console.log('--->', this.userType.data.user_type)
  },
  methods: {
    async getLetterApiSettings() {
      await axios.get('/api-token/default?module=physical-letters').then(settings => {
        if (settings.status) {
          this.letter_client_id = settings.data.data.client_id
          this.letter_secret = settings.data.data.secret
        }
      })
    },
    async getDetails(id) {
      this.loader = true
      const headers = {
        clientId: this.letter_client_id,
        secret: this.letter_secret,
      }
      const templateDetails = await axiosletter.get(`/letters-api/view-letter?templateID=${id}`, {
        headers,
      })
      if (templateDetails.status) {
        setTimeout(() => {
          this.busy = false
          console.log('templateDetails', templateDetails)
          this.pdfLink = templateDetails.data.data.pdf
          this.name = templateDetails.data.data.data.name
          this.document_name = templateDetails.data.data.data.document_name || ''
          this.description = templateDetails.data.data.data.description
          this.apiBody = templateDetails.data.data.apiBody
          this.companyname = this.user_type === 'super-admin' ? templateDetails.data.data.data.get_company.name : 'N/A'
        }, 2000)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/quill.scss';
.ql-container.ql-snow{
  height: 150px !important;
}

.modal-lg {
    max-width: 1000px;
}
.variables-admin {
  overflow-y: scroll;
  max-height: 315px;
}

.variables {
  overflow-y: scroll;
  max-height: 400px;
}
</style>
